import React, { useState } from 'react';
import classNames from 'classnames';
import { IoChevronDown, IoChevronUp } from 'react-icons/io5';
import AdaptableCard from './AdaptableCard';

const CollapsibleCard = ({
  title,
  icon,
  children,
  defaultCollapsed = false,
  className,
  bodyClass,
  headerClassName,
  titleClassName,
  iconClassName,
  contentClassName,
  headerRight,
  hideToggle = false,
  toggleClassName,
  collapseIcon,
  expandIcon,
  ...rest
}) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

  const toggleCollapse = () => {
    setIsCollapsed((prev) => !prev);
  };

  return (
    <AdaptableCard
      className={classNames('p-0', className)}
      bodyClass={classNames('p-4', bodyClass)}
      {...rest}
    >
      <div className="w-full">
        <div className={classNames('flex items-center justify-between', headerClassName)}>
          <div className="flex items-center gap-2 min-w-0">
            {icon ? (
              <span className={classNames('text-xl shrink-0 text-black dark:text-white', iconClassName)}>
                {icon}
              </span>
            ) : null}
            {title ? (
              typeof title === 'string' ? (
                <h5 className={classNames('mb-0', titleClassName)}>{title}</h5>
              ) : (
                title
              )
            ) : null}
          </div>

          <div className="flex items-center gap-2">
            <div className="cursor-pointer text-sm text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-white transition">
              {headerRight}
            </div>
            {!hideToggle && (
              <button
                type="button"
                onClick={toggleCollapse}
                aria-expanded={!isCollapsed}
                className={classNames(
                  'text-xl text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-white transition',
                  toggleClassName,
                )}
              >
                {isCollapsed ? collapseIcon || <IoChevronDown /> : expandIcon || <IoChevronUp />}
              </button>
            )}
          </div>
        </div>

        {!isCollapsed && <div className={classNames('mt-3', contentClassName)}>{children}</div>}
      </div>
    </AdaptableCard>
  );
};

export default CollapsibleCard;
